<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_iii"></a>BLOOD VINES</h1>
<p class="image"><img alt="Image" src="images/line.gif"/></p>
<p class="author">ERICA SPINDLER</p>
<p class="editor">ST. MARTIN’S PRESS <img alt="Image" src="images/publisher.jpg"/> NEW YORK</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?37f4a177